import { useCallback, useState } from 'react';
import { FileWithDocType } from 'ui/atoms/file-upload';

export interface FileIndexed {
  index: number;
  document: FileWithDocType;
}

export const useMultipleSingleFileUploads = () => {
  const [documentsUploaded, setDocumentsUploaded] = useState<FileIndexed[]>([
    { index: 0, document: { file: null, documentType: null } },
  ]);
  const [error, setError] = useState('');

  const addMoreDocuments = useCallback(() => {
    const lastIndex = documentsUploaded[documentsUploaded.length - 1]?.index;
    setDocumentsUploaded([
      ...documentsUploaded,
      { index: lastIndex + 1, document: { file: null, documentType: null } },
    ]);
  }, [JSON.stringify(documentsUploaded)]);

  const onChangeDocument = useCallback(
    (document: FileWithDocType, index: number) => {
      setError('');

      if (!document && documentsUploaded?.length === 1) {
        // remove document when only one document is left
        setDocumentsUploaded([{ index: 0, document: { file: null, documentType: null } }]);
        return;
      }

      if (!document) {
        // remove document
        setDocumentsUploaded(documentsUploaded.filter((documentObj) => documentObj.index !== index));
        return;
      }

      // change uploaded file or document type
      const filesToUpload = documentsUploaded.map((documentObj) => {
        if (documentObj.index === index) {
          return { ...documentObj, document };
        }
        return documentObj;
      });

      setDocumentsUploaded(filesToUpload);
    },
    [JSON.stringify(documentsUploaded)],
  );

  return {
    addMoreDocuments,
    documentsUploaded,
    onChangeDocument,
    error,
    setError,
  };
};
